"use strict";
exports.__esModule = true;
exports.EvaluationDetails = void 0;
var EvaluationDetails = /** @class */ (function () {
    function EvaluationDetails(configSyncTime, initTime, reason) {
        this.configSyncTime = configSyncTime;
        this.initTime = initTime;
        this.reason = reason;
        this.serverTime = Date.now();
    }
    EvaluationDetails.uninitialized = function () {
        return new EvaluationDetails(0, 0, 'Uninitialized');
    };
    EvaluationDetails.unsupported = function (configSyncTime, initialUpdateTime) {
        return new EvaluationDetails(configSyncTime, initialUpdateTime, 'Unsupported');
    };
    EvaluationDetails.persisted = function (configSyncTime, initialUpdateTime) {
        return new EvaluationDetails(configSyncTime, initialUpdateTime, 'Persisted');
    };
    EvaluationDetails.make = function (configSyncTime, initialUpdateTime, reason) {
        return new EvaluationDetails(configSyncTime, initialUpdateTime, reason);
    };
    return EvaluationDetails;
}());
exports.EvaluationDetails = EvaluationDetails;
